
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.5 5h-21A3.504 3.504 0 002 8.5v15A3.504 3.504 0 005.5 27h21a3.504 3.504 0 003.5-3.5v-15A3.504 3.504 0 0026.5 5zm-.886 5.79l-9 7a1 1 0 01-1.228 0l-9-7a1.002 1.002 0 01.486-1.792 1 1 0 01.742.213L16 15.733l8.386-6.522a1 1 0 011.228 1.578z","fill":"currentColor"}})])
          )
        }
      }
    